module.exports = __webpack_public_path__ + "bg35-paint-ed358cd61fef115ddd680f0f4dfbd7dd.png";